/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ToastContainer, GAProductViewHelper, GACartHelper } from 'sarsaparilla';

import {
    useAIReferralCapture,
    useUpdateReduxWithAccountData,
    // useLoadRecaptcha,
    useGTMPageLoggingOnRouteChange,
    useHotjarIdentifyOnRouteChange,
    useHotjarStateChangeOnRouteChange,
    useFeatureFlagSettingForGTM,
    useWebVitalsInGTM,
    useEnrichAddToCartEvents,
} from './ExternalAppBootstrap.utils';

/**
 * This component renders no UI.
 *
 * Loads Recaptcha, handles user authentication state across micro frontends, and sends
 * page view data to Google Tag Manager (GTM)
 */
export function ExternalAppBootstrap() {
    // Capture AI referral conversation_id from URL before any auth flow
    useAIReferralCapture();

    // Check local storage for auth information and add it to the redux store
    // so we can persist user login across micro frontends
    useUpdateReduxWithAccountData();

    // Load recaptcha
    // useLoadRecaptcha();

    // Send a page view to GTM with the account ID if available
    useGTMPageLoggingOnRouteChange();

    // Keep Hotjar in sync with SPA route changes
    useHotjarStateChangeOnRouteChange();
    useHotjarIdentifyOnRouteChange();

    // Send LaunchDarkly feature flags to GTM
    useFeatureFlagSettingForGTM();

    // Initialize web vitals
    useWebVitalsInGTM();

    // Intercept and enrich add_to_cart events with recommendation data
    useEnrichAddToCartEvents();

    // Returns logic-only, non-visible components
    return (
        <>
            <ToastContainer />
            <GAProductViewHelper />
            <GACartHelper />
        </>
    );
}

// cSpell:ignore hotjar
